<div class="grid quick_links">
  <img src="https://acornstoragedev.blob.core.windows.net/logo/Logo_White.svg" alt="" />

  <h3>© {{ currentYear }} NobleOak</h3>

  <ul>
    <li><a href="https://wealthmaximiser.com.au/">Home</a></li>

    <li><a href="https://wealthmaximiser.com.au/about-us">About Us</a></li>

    <li><a href="https://wealthmaximiser.com.au/pricing">Pricing</a></li>

    <li><a href="https://wealthmaximiser.com.au/media">Media</a></li>

    <li><a href="https://www.wealthmaximiser.com.au/financial-services-guide/">Financial Services Guide</a></li>

    <li><a href="https://www.wealthmaximiser.com.au/terms-and-conditions/">Terms & Conditions</a></li>

    <li><a href="https://www.wealthmaximiser.com.au/privacy-policy/">Privacy Policy</a></li>
  </ul>

  <div class="disclaimer">
    The information contained on this website is of a general nature only and
    does not take into consideration your objectives, financial situation or
    needs. Before making a decision to purchase or continue with Wealth
    Maximiser, you should review the
    <a href="https://www.wealthmaximiser.com.au/financial-services-guide/">
      Financial Services Guide
    </a>
    and
    <a href="https://www.wealthmaximiser.com.au/terms-and-conditions/">
      Wealth Maximiser Terms & Conditions
    </a>
    and consider this information having regard to your own objectives,
    financial situation and needs. Wealth Maximiser is operated by NobleOak
    Services Limited ACN 112 981 718 AFSL 286798.
  </div>

  <div class="address">
    <div>Wealth Maximiser <br />Level 4/44 Market St Sydney NSW 2000</div>

    <mat-divider [vertical]="true"></mat-divider>

    <img src="assets/images/lockup-footer.svg" alt="" />
  </div>
</div>
